import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-attachment-view',
  templateUrl: './attachment-view.component.html',
  styleUrls: ['./attachment-view.component.css']
})
export class AttachmentViewComponent implements OnInit{
  imagePath: any;
  title: string = '';
  fileType: string = '';
  zoom_to: any = 1
  screenName: any;
  // pdfSrc = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";
  constructor(public dialogRef: MatDialogRef<AttachmentViewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog) {
  }

  ngOnInit(): void {
    debugger
    this.title = this.data.title;
    this.screenName = this.data.screenName;
    this.imagePath = this.data.src;
    this.fileType = this.data.fileType;
    console.log('image path', this.imagePath)
  }
  zoomIn() {
    this.zoom_to = this.zoom_to + 0.25;
  }
  zoomOut() {
    if (this.zoom_to > 1) {

      this.zoom_to = this.zoom_to - 0.25;

    }

  }
  onClose() {
    this.dialogRef.close({ event: false });

  }
  onClick(event: any) {
    debugger
    const src = `data:text/csv;base64,${this.imagePath}`;
    const link = document.createElement("a")
    link.href = src
    if (this.fileType=='img'){
      link.download = 'MSMEImage.png'
    }else if (this.fileType=='pdf'){
      link.download = 'MSMEFile.pdf'
    }
    link.click()
    link.remove()
  }
}
